import { render, staticRenderFns } from "./PatientProductsSection.vue?vue&type=template&id=37fd2c9a&"
import script from "./PatientProductsSection.vue?vue&type=script&lang=js&"
export * from "./PatientProductsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports